import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import { useAuth } from "hooks/useAuth";
import NavBarModal from "./NavbarModal";
import ThemeToggle from "./ThemeToggle";
import { profileIcon, settingsIcon, tableIcon, exitIcon, analyticsIcon } from "assets";
import Icon from "components/Icon";

const navLinks = {
  tables: [
    {
      title: "Продажі та Ціни",
      items: [
        {
          label: "Рекомендовані ціни",
          path: "/recommendation",
          requiredPermission: "recommendations:view",
        },
        { label: "Ловушки", path: "/trap", requiredPermission: "traps:view" },
        {
          label: "Виключення",
          path: "/exclusions",
          requiredPermission: "exclusions:view",
        },
      ],
    },
    {
      title: "Постачання та Джерела",
      items: [
        {
          label: "Постачальники",
          path: "/products",
          requiredPermission: "products:view",
        },
        { label: "Партнери", path: "/partners", requiredPermission: "partners:view" },
        {
          label: "Очікуваний прихід",
          path: "/supply-report",
          requiredPermission: "supply_report:view",
        },
      ],
    },
  ],
  analyz: [
    {
      title: "Команда та Ефективність",
      items: [
        {
          label: "Загальні показники компанії",
          path: "/general",
          requiredPermission: "dashboard-general:view",
        },
        {
          label: "Статистика менеджерів",
          path: "/stats-manager",
          requiredPermission: "dashboard-sellers-stats:view",
        },
        {
          label: "Статистика менеджерів БОТ",
          path: "/manager-bot",
          requiredPermission: "dashboard-sellers-bot:view",
        },
      ],
    },
    {
      title: "Ринок та Асортимент",
      items: [
        {
          label: "Аналітика Prom",
          path: "/analyz-prom",
          requiredPermission: "dashboard-prom:view",
        },
        {
          label: "ABC - аналіз",
          path: "/abc",
          requiredPermission: "dashboard-abc:view",
        },
        {
          label: "Парсинг конкурентів",
          path: "/competitors-parsing",
          requiredPermission: "dashboard-competitors-parsing:view",
        },
      ],
    },
  ],
  settings: [
    { label: "Керування ботом", path: "/bot-settings", requiredPermission: "bot:view" },
    {
      label: "Статуси оновлення",
      path: "/shops-by-suppliers",
      requiredPermission: "shop-settings:view",
    },
  ],
};

// Компонент навігаційного меню
const NavBar = () => {
  const [openModalKey, setOpenModalKey] = useState("");
  const { logout, isAllowed } = useAuth();

  // Універсальна функція для фільтрації груп
  const filterGroups = (groups) => {
    return groups
      .map((group) => ({
        ...group,
        items: group.items.filter((link) => isAllowed(link.requiredPermission)),
      }))
      .filter((group) => group.items.length > 0);
  };

  // Фільтруємо посилання
  const filteredLinks = {
    tables: filterGroups(navLinks.tables),
    analyz: filterGroups(navLinks.analyz),
    settings: navLinks.settings.filter((link) => isAllowed(link.requiredPermission)),
  };

  // Закриття модального вікна
  const closeModal = () => setOpenModalKey("");

  // Обчислення видимості кнопок
  const visibleLinksCount = {
    tables: filteredLinks.tables.length,
    analyz: filteredLinks.analyz.length,
    settings: filteredLinks.settings.length,
  };

  // Функція рендеру кнопки
  const renderNavButton = (key, icon, altText) => {
    if (visibleLinksCount[key] > 0) {
      return (
        <button
          onClick={() => setOpenModalKey(key)}
          className={openModalKey === key ? "active" : ""}
        >
          <img className="icon" src={icon} alt={altText} />
        </button>
      );
    }
    return null;
  };

  return (
    <>
      <nav id="navbar">
        <div className="navbar-content">
          {renderNavButton("tables", tableIcon, "Таблиці")}
          {renderNavButton("settings", settingsIcon, "Налаштування")}
          {renderNavButton("analyz", analyticsIcon, "Аналітика")}
        </div>

        <div className="navbar-content">
          <ThemeToggle />
          <button onClick={() => setOpenModalKey("profile")}>
            <img className="icon" src={profileIcon} alt="Профіль" />
          </button>
        </div>
      </nav>

      {openModalKey === "tables" && visibleLinksCount.tables > 0 && (
        <NavBarModal
          key="tables"
          groups={filteredLinks.tables}
          closeModal={closeModal}
        />
      )}

      {openModalKey === "analyz" && visibleLinksCount.analyz > 0 && (
        <NavBarModal key="analyz" groups={filteredLinks.analyz} closeModal={closeModal} />
      )}

      {openModalKey === "settings" && visibleLinksCount.settings > 0 && (
        <NavBarModal
          key="settings"
          items={filteredLinks.settings}
          closeModal={closeModal}
        />
      )}

      {openModalKey === "profile" && (
        <NavBarModal
          items={[]}
          closeModal={closeModal}
          contentClassName="modal-content-nf"
        >
          {isAllowed("users:view") && (
            <NavLink to="/admin-profile" onClick={closeModal}>
              Адмін панель
            </NavLink>
          )}
          {isAllowed("api-tokens:manage") && (
            <NavLink to="/developer" onClick={closeModal}>
              Документація API
            </NavLink>
          )}
          <button id="logout-button" onClick={logout}>
            <Icon src={exitIcon} />
            <span>Вийти</span>
          </button>
        </NavBarModal>
      )}
    </>
  );
};

export default NavBar;
